module.exports = __webpack_public_path__ + "assets/plus.9c04eaa1.svg";